module.exports = __webpack_public_path__ + "static/p2-120dbcf0ba842fed0fce41497e437657.jpg";